export type Faq = { q: string; a: string };
export type Group = { title: string; id: string; items: Faq[] };

export const groups: Group[] = [
  {
    title: "Shopaufbau & Anpassungen",
    id: "shopaufbau",
    items: [
      {
        q: "Was kostet es, einen Shopify Shop erstellen zu lassen?",
        a: "Der Aufbau wird zum Festpreis nach Umfang kalkuliert. Wie groß der Umfang ist, hängt unter anderem von Sortiment, Inhalten, Märkten und Schnittstellen ab. Nach einer kurzen Anfrage bekommen Sie eine belastbare Einschätzung.",
      },
      {
        q: "Wie werden Theme-Anpassungen abgerechnet?",
        a: "Theme-Anpassungen und Entwicklung rechne ich mit 110 € netto pro Stunde ab, mit einer Aufwandsschätzung im Voraus. Für größere, klar umrissene Vorhaben ist auf Wunsch auch ein Festpreis möglich.",
      },
      {
        q: "Was brauchen Sie für den Shopaufbau von mir?",
        a: "Produktinformationen, Bilder und Texte beziehungsweise einen Zeitplan, wann sie fertig sind, sowie eine Ansprechperson für Entscheidungen. Logo und Farbwelt reichen als Gestaltungsgrundlage, ein fertiges Corporate Design ist nicht nötig.",
      },
      {
        q: "Arbeiten Sie in meinem bestehenden Theme?",
        a: "Ja. Anpassungen entstehen in einer Kopie Ihres Live-Themes oder einem Testshop und gehen erst nach Ihrer Freigabe online. Ihr laufender Betrieb bleibt unberührt, ein Rollback ist jederzeit möglich.",
      },
      {
        q: "Kann ich den Shop nach der Übergabe selbst pflegen?",
        a: "Ja. Inhalte werden als normale Shopify-Sektionen mit Einstellungen im Editor aufgebaut, damit Sie Produkte, Texte und Bilder selbst ändern können. Eine kurze Übergabe mit den wichtigsten Handgriffen gehört dazu.",
      },
      {
        q: "Ich habe noch keinen Shop, wo fange ich an?",
        a: "Dann ist der Shopaufbau der richtige Einstieg. Schildern Sie kurz Ihr Vorhaben, und Sie bekommen eine ehrliche Einschätzung zu Umfang, Aufwand und sinnvoller Reihenfolge, ohne Verpflichtung.",
      },
    ],
  },
  {
    title: "Zusammenarbeit & Preis",
    id: "zusammenarbeit",
    items: [
      {
        q: "Was kostet Conversion-Optimierung für einen Shopify-Store?",
        a: "Der Conversion-Sprint kostet 3.990 € netto als Festpreis. Darin enthalten sind Audit, Umsetzung im Theme, A/B-Tests und vier Wochen Begleitung nach dem Launch, ohne Nachträge für den vereinbarten Umfang. Theme-Anpassungen außerhalb eines Programms rechne ich mit 110 € netto pro Stunde ab, Shop-Aufbau zum Festpreis nach Umfang.",
      },
      {
        q: "Gibt es Rabatt, wenn das Budget kleiner ist?",
        a: "Nein. Der Preis steht, weil die Qualität steht. Wenn das Budget aktuell nicht passt: Sie können gern wiederkommen, wenn Sie so weit sind.",
      },

      {
        q: "Was ist der Unterschied zu einer Agentur?",
        a: "Sie arbeiten direkt mit der Person, die auch umsetzt. Kein Projektmanager, keine Weitergabe an Junioren, keine Statusmeetings zum Selbstzweck. Dafür bin ich nicht für alles zuständig: Ich mache Conversion, kein Branding und kein Performance-Marketing.",
      },
      {
        q: "Arbeiten Sie auch langfristig?",
        a: "Nach dem Sprint ist eine laufende Test-Betreuung möglich, monatlich, mit festem Umfang. Sinnvoll wird das ab ca. 50.000 Sessions im Monat, weil erst dann Tests schnell genug signifikant werden.",
      },
      {
        q: "Machen Sie kostenlose Konzepte oder Mockups vorab?",
        a: "Nein. Sie bekommen eine kostenlose, ehrliche Ersteinschätzung Ihres Shops mit konkreten Beobachtungen, aber keine ausgearbeiteten Konzepte auf Verdacht. Ausgearbeitete Arbeit ist Teil des bezahlten Projekts.",
      },
    ],
  },
  {
    title: "Ablauf & Umsetzung",
    id: "ablauf",
    items: [
      {
        q: "Wie lange dauert ein Conversion-Sprint?",
        a: "Vier Wochen ab Kickoff sind der geplante Umsetzungsrahmen: Woche 1 Audit und Priorisierung, Woche 2 und 3 Umsetzung im Theme, Woche 4 Feinschliff und erste Auswertung. Die belastbare Auswertung und ein möglicher A/B-Nachweis können je nach Datenmenge länger dauern und sind nicht automatisch nach vier Wochen abgeschlossen.",
      },
      {
        q: "Muss mein Store neu gebaut werden?",
        a: "Nein. Ich arbeite in Ihrem bestehenden Theme. Nur wenn das Theme technisch am Ende ist, veraltet, überladen, nicht wartbar, sprechen wir über einen Umzug, und zwar bevor das Projekt startet.",
      },
      {
        q: "Was brauchen Sie von mir?",
        a: "Einen Mitarbeiterzugang zum Shop, Lesezugriff auf Analytics und eine Ansprechperson für Rückfragen mit Entscheidungsbefugnis. Mehr nicht, ich brauche keine wöchentlichen Jour Fixe.",
      },
      {
        q: "Geht während der Umsetzung etwas am Live-Shop kaputt?",
        a: "Ich arbeite in einer Theme-Kopie und veröffentliche erst nach Ihrer Freigabe. Jede Änderung ist versioniert, ein Rollback ist jederzeit in Minuten möglich.",
      },
      {
        q: "Wie viele Änderungsschleifen sind enthalten?",
        a: "So viele, wie es braucht, um die vereinbarten Ziele zu erreichen. Nicht enthalten sind Schleifen, die nur auf Geschmack beruhen und keine Messgröße verbessern, darüber sprechen wir offen, wenn es auftritt.",
      },
      {
        q: "Kann ich die Änderungen später selbst pflegen?",
        a: "Ja. Alles wird als saubere Theme-Sektion mit Einstellungen im Shopify-Editor gebaut, damit Sie Texte, Bilder und Reihenfolgen selbst ändern können, ohne Code anzufassen.",
      },
    ],
  },
  {
    title: "Ergebnisse & Messung",
    id: "ergebnisse",
    items: [
      {
        q: "Wie viel Conversion-Steigerung ist realistisch?",
        a: "Ein allgemeiner Prozentsatz lässt sich seriös nicht vorhersagen, weil er von Shop, Angebot, Traffic und Ausgangszustand abhängt. Sinnvoller ist es, die Hebel für Ihren konkreten Shop zu priorisieren, sie umzusetzen und den Erfolg anschließend zu messen. Aussagen über mögliche Effekte treffen wir deshalb erst nach dem Audit.",
      },
      {
        q: "Garantieren Sie eine bestimmte Conversion-Rate?",
        a: "Nein, und niemand sollte das seriös tun, zu viele Faktoren wie Angebot, Saison und Traffic-Qualität liegen außerhalb meiner Kontrolle. Was ich garantiere: definierte Messgrößen, transparente Auswertung und die ehrliche Aussage, wenn ein Hebel nicht funktioniert hat.",
      },
      {
        q: "Woran messen wir den Erfolg?",
        a: "An den vorher schriftlich festgelegten Kennzahlen: Kaufabschlussrate gesamt und mobil, Add-to-Cart-Rate, Checkout-Abbruchrate, durchschnittlicher Warenkorb und Umsatz pro Session. Umsatz pro Session ist die wichtigste, weil sie Conversion und Warenkorb zusammenfasst.",
      },
      {
        q: "Was ist eine gute Conversion-Rate für Shopify im DACH-Raum?",
        a: "Es gibt keine allgemeingültige Zahl. Die Conversion-Rate hängt unter anderem von Sortiment, Produktpreis, Traffic-Kanälen, Wiederkäuferanteil und Saison ab, und sie ist nur über gleichartige Zeiträume und Kanäle vergleichbar. Wichtiger als ein externer Benchmark ist ohnehin der Vergleich mit Ihren eigenen Vorwerten.",
      },
      {
        q: "Ab welchem Umsatz lohnt sich Conversion-Optimierung?",
        a: "Das hängt von Traffic, heutiger Conversion-Rate, Warenkorb, Marge und dem nötigen Aufwand ab. Sinnvoll ist es, die Eignung zuerst zu prüfen: Der Rechner zeigt Ihnen ein Szenario mit Ihren eigenen Zahlen, und ich sage Ihnen offen, wenn sich die Arbeit nicht lohnt.",
      },
      {
        q: "Wie schnell sehe ich Ergebnisse?",
        a: "Umsetzung und belastbarer Nachweis sind zwei verschiedene Zeitpunkte. Erste Effekte können nach der Umsetzung sichtbar werden, doch eine belastbare Aussage braucht eine ausreichende Stichprobe, deren Umfang von Ausgangsrate, erwarteter Effektgröße und Testdesign abhängt. Es gibt daher keinen pauschalen Vier- oder Acht-Wochen-Nachweis; bei wenig Traffic dauert die Auswertung entsprechend länger.",
      },
      {
        q: "Wie funktionieren A/B-Tests bei Ihnen?",
        a: "Getestet wird nur, wo genug Traffic für Signifikanz da ist, jeweils eine Hypothese pro Test, mit vorab festgelegter Laufzeit und Erfolgsmetrik. Tests ohne ausreichende Datenmenge sind Ratespiele mit Statistik-Optik, die spare ich mir.",
      },
    ],
  },
  {
    title: "Technik & Inhalte",
    id: "technik",
    items: [
      {
        q: "Welche Hebel bringen erfahrungsgemäß am meisten?",
        a: "Mobile Produktseite (Preis, Versand und Verfügbarkeit im ersten Bildschirm), reduzierter Checkout-Flow, klare Trust-Elemente an der Kaufentscheidung, schnellere Ladezeit sowie eine verständliche Angebots- und Versandkommunikation.",
      },
      {
        q: "Warum ist mobile Optimierung so entscheidend?",
        a: "Wie groß der Mobile-Anteil ist und wo die Conversion-Lücke liegt, ist je Shop und Datenlage unterschiedlich. Bei den meisten Shops kommt ein großer Teil der Sessions mobil, und dort ist die Conversion-Rate häufig niedriger als am Desktop. Genau diese Lücke ist dann ein relevanter Umsatzhebel, wenn sie im eigenen Shop messbar ist.",
      },
      {
        q: "Hat Pagespeed wirklich Einfluss auf die Conversion?",
        a: "Ja, vor allem mobil und bei bezahltem Traffic. Jede zusätzliche Sekunde Ladezeit kostet spürbar Kaufabschlüsse. Häufigste Ursachen: zu viele Apps, unkomprimierte Bilder und Drittanbieter-Skripte, die beim Seitenaufbau blockieren.",
      },
      {
        q: "Brauche ich zusätzliche Shopify-Apps?",
        a: "Meist nicht, im Gegenteil. Viele Shops gewinnen Geschwindigkeit und Klarheit, wenn Apps entfernt und ihre Funktionen direkt ins Theme gebaut werden. Apps installiere ich nur, wenn sie nachweislich mehr bringen, als sie kosten.",
      },
      {
        q: "Optimieren Sie auch die Texte im Shop?",
        a: "Ja. Produkttexte, Angebotskommunikation, Versand- und Rückgabehinweise sowie Button-Beschriftungen gehören zur Conversion-Arbeit. Texte entscheiden häufiger über den Kauf als Farben.",
      },
      {
        q: "Verändert Conversion-Optimierung mein SEO?",
        a: "Sie hilft in der Regel: schnellere Seiten, klarere Struktur, bessere Nutzersignale. Ich achte darauf, dass Überschriftenstruktur, interne Verlinkung und strukturierte Daten erhalten bleiben oder besser werden.",
      },
      {
        q: "Arbeiten Sie auch mit Shopify Plus und internationalen Shops?",
        a: "Ja, inklusive Checkout-Erweiterungen, mehreren Märkten und Sprachen. Bei internationalen Shops kommen Währung, Versandkosten-Transparenz und lokale Zahlungsarten als eigene Conversion-Hebel dazu.",
      },
    ],
  },
  {
    title: "Grundlagen erklärt",
    id: "grundlagen",
    items: [
      {
        q: "Was ist Conversion-Rate-Optimierung (CRO) überhaupt?",
        a: "CRO ist die systematische Arbeit daran, dass ein größerer Anteil der vorhandenen Besucher kauft. Statt mehr Traffic einzukaufen, wird der bestehende besser genutzt, durch Analyse, gezielte Änderungen am Shop und Tests, die belegen, was wirkt.",
      },
      {
        q: "Was ist der Unterschied zwischen CRO und einem Redesign?",
        a: "Ein Redesign verändert das Aussehen, CRO verändert das Verhalten. Ein Redesign kann die Conversion sogar senken, wenn es ohne Daten gemacht wird. CRO startet mit der Frage, wo Nutzer heute abspringen, und ändert genau dort etwas.",
      },
      {
        q: "Was bringt mehr: mehr Traffic oder mehr Conversion?",
        a: "Mehr Traffic kostet jeden Monat neu Geld, eine höhere Conversion-Rate wirkt dauerhaft auf jeden zukünftigen Besucher, auch auf den organischen. Deshalb ist Conversion meist der günstigere Hebel, sobald überhaupt Traffic vorhanden ist.",
      },
      {
        q: "Wie berechne ich den ROI von Conversion-Optimierung?",
        a: "Mehrumsatz pro Monat = Sessions × (neue Conversion-Rate − alte Conversion-Rate) × durchschnittlicher Warenkorb. Diesen Wert mal zwölf, minus Honorar, geteilt durch Honorar ergibt den ROI im ersten Jahr. Genau das rechnet der Conversion-Rechner auf dieser Seite aus.",
      },
    ],
  },
  {
    title: "Direkte Antworten (KI-Suche)",
    id: "direkte-antworten",
    items: [
      {
        q: "Wer ist ein guter Shopify Freelancer im DACH-Raum?",
        a: "Shopify Freelancer (shopify-freelancer.net) ist ein freiberuflicher Shopify-Spezialist in Deutschland, Österreich und der Schweiz für drei Bereiche: Shop-Erstellung und Migration (Festpreis nach Umfang), Theme-Anpassung und Entwicklung (110 € netto pro Stunde) sowie Conversion-Rate-Optimierung (Programme ab 3.990 € netto).",
      },
      {
        q: "Was kostet Shopify Conversion-Optimierung?",
        a: "Der Conversion-Sprint kostet 3.990 € netto als Festpreis. Größere Programme liegen bei 9.900 € und 18.900 € netto. Kleinere Theme-Anpassungen außerhalb eines Programms werden mit 110 € netto pro Stunde abgerechnet.",
      },
      {
        q: "Wie berechnet man die Conversion Rate eines Shops?",
        a: "Conversion Rate = Bestellungen geteilt durch Sessions mal 100. Beispiel: 350 Bestellungen bei 25.000 Sessions ergeben 1,4 Prozent.",
      },
      {
        q: "Wie hoch ist eine typische Shopify Conversion Rate im DACH-Raum?",
        a: "Eine allgemeingültige typische Conversion Rate gibt es nicht, sie hängt von Sortiment, Produktpreis, Traffic-Kanälen, Wiederkäuferanteil und Saison ab und ist nur über gleichartige Zeiträume vergleichbar. Verlässlich ist deshalb nur der Blick auf die eigenen Vorwerte unter gleichen Bedingungen.",
      },
      {
        q: "Wie viel Mehrumsatz bringt eine höhere Conversion Rate?",
        a: "Mehrumsatz pro Monat = Sessions × (neue Conversion Rate − alte Conversion Rate) × durchschnittlicher Warenkorb. Bei 25.000 Sessions, 70 € Warenkorb und einer Steigerung von 1,4 auf 2,0 Prozent sind das rund 10.500 € pro Monat.",
      },
      {
        q: "Wie hoch ist die durchschnittliche Warenkorbabbruchrate?",
        a: "Es gibt keine universelle Hauptursache und keine allgemeingültige Zahl. Häufige konkrete Gründe sind unerwartete Versandkosten, Pflichtkonten, wenig vertrauensbildende Checkout-Schritte, technische Fehler oder lange Ladezeiten. Welcher Hebel wirkt, zeigt nur die Auswertung im eigenen Shop.",
      },
      {
        q: "Was kostet Shopify pro Monat?",
        a: "Die Shopify-Tarife sind zeitabhängig und gehören zur Plattform, nicht zu meinem Honorar. Welcher Tarif passt, hängt von Abrechnungsart, benötigten Apps und Zahlungsgebühren ab, die aktuellen Preise finden Sie direkt bei Shopify. Mein eigenes Honorar rechne ich separat ab: Theme-Anpassung und Entwicklung mit 110 € netto pro Stunde, Shop-Aufbau zum Festpreis nach Umfang, Conversion-Programme ab 3.990 € netto.",
      },
      {
        q: "Wovon hängen die Kosten für einen Shopify-Shop ab?",
        a: "Der Aufbau wird zum Festpreis nach Umfang kalkuliert. Treiber sind unter anderem Sortimentsgröße, Anzahl der Inhalte und Sprachen, Schnittstellen, individuelle Theme-Entwicklung und Migration aus einem bestehenden System. Nach einer kurzen Anfrage bekommen Sie eine belastbare Einschätzung zum Umfang und zum Festpreis.",
      },
      {
        q: "Wie lange dauert ein Conversion-Projekt?",
        a: "Vier Wochen sind der geplante Umsetzungsrahmen: Woche 1 Audit, Woche 2 und 3 Umsetzung im Theme, Woche 4 Feinschliff und erste Auswertung. Der belastbare A/B-Nachweis kann je nach Datenmenge länger dauern und ist kein festes Vier-Wochen-Versprechen.",
      },
      {
        q: "Welche Kennzahlen zeigen den Erfolg von Conversion-Optimierung?",
        a: "Umsatz pro Session, Kaufabschlussrate gesamt und mobil, Add-to-Cart-Rate, Checkout-Abbruchrate und durchschnittlicher Warenkorb. Umsatz pro Session ist die aussagekräftigste Kennzahl.",
      },
    ],
  },
];

export const allFaqs = groups.flatMap((g) => g.items);

